import React from 'react';
import Dropdown from '../../../Form/Dropdown/Dropdown';
import PhoneNumInput from '../../../Form/Inputs/PhoneNumInput';

import Api from '../../../Helpers/Api';
import Validator from '../../../Helpers/Validator';
import "./SendToCell.scss";

const LOCAL_STATES = {
    MAIN: 1,
    THANKS: 2,
    ERROR: 3
};

export default class SendToCell extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentState: LOCAL_STATES.MAIN,
            inputData: {},
            errors: {}
        };

        this.changeState = this.changeState.bind(this);
        this.setSendToCellState = this.setSendToCellState.bind(this);
    }

    render(props) {
        let displayError = Object.keys(this.state.errors).length > 0 ? this.state.errors[Object.keys(this.state.errors)[0]] : '';
        return (<section className="send-to-cell info-panel-sections">
            {this.state.currentState === LOCAL_STATES.MAIN &&
                (<section className="info-panel-section">
                    <h2>SEND #<br />TO CELL</h2>
                    <p className="validation-errors">
                        {displayError}
                    </p>

                    <form action="">
                        <fieldset>
                            <legend>Cellular Phone Number</legend>
                            <PhoneNumInput
                            placeholder="Phone Number"
                            name="phone"
                            onChange={this.setSendToCellState}
                            isInvalid ={ this.state.errors['phone'] }
                            />
                        </fieldset>

                        <fieldset>
                            <legend>Cellular Phone Carrier</legend>
                            <Dropdown
                                items={this.props.phoneCarrier}
                                placeholder="Select"
                                name="phoneCarrier"
                                onSelect={this.setSendToCellState}
                                isInvalid={this.state.errors['phoneCarrier']}
                                selectedValue={this.state.inputData.phoneCarrier}
                            />
                        </fieldset>

                        <button type="button" onClick={()=>this.submitRequest()}>SEND</button>
                    </form>
                </section>)
            }

            {(this.state.currentState === LOCAL_STATES.THANKS &&
                <ThankYouScreen />
            )}

            {(this.state.currentState === LOCAL_STATES.ERROR &&
                <ErrorScreen />
            )}

        </section>);
    }

    changeState(state) {
        this.setState({
            currentState: state
        });
    }

    setSendToCellState(e) {
        let field = e.target.name;
        let value = e.target.value;

        this.state.inputData[field] = value;

        return this.setState({
            inputData: this.state.inputData
        });
    }

    isValid() {
        let isValid = false;
        this.state.errors = {};
        let form = this.state.inputData;

        if (!form.phoneCarrier) {
            this.state.errors['phoneCarrier'] = 'Please choose phone carrier!';
        }

        if (!Validator.phone(form.phone)) {

          
            this.state.errors['phone'] = 'Please enter a valid phone number!';
        }

        this.setState({
            errors: this.state.errors
        });

        if (!Object.keys(this.state.errors).length) {
            isValid = true;
        }

        return isValid;
    }

  


    submitRequest() {

       
        if (this.isValid()) {

            let response = Api.sendToCell(this.state.inputData)
                .then((res) => {
                    let nextStep = res.ok ? LOCAL_STATES.THANKS : LOCAL_STATES.ERROR;

                    this.setState({
                        currentState: nextStep
                    });
                });

        }
    }

}

function ThankYouScreen(props) {
    return (<section className="info-panel-section thank-you">
        <img src="/images/appointment/icon-success.svg" alt="icon-success" />
                    <h2 >Thank you</h2>
                    <span >Your request has been sent successfully.</span>
                </section>);
}

function ErrorScreen(props) {
    return (<section className="info-panel-section error">
                    <h2>
                        Error
                    </h2>
                    <span>
                        Please contact support for the<br />
                         following email ...
                    </span>
                </section>);
}


// WEBPACK FOOTER //
// ./Src/Shared/Header/InfoPanel/SendToCell/SendToCell.jsx